// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FPSviceBRNYINPm0E0lN{width:100%;height:100%;display:flex}.qUNKdg8HF0A__N47V84f{height:100%}.mFYtB8TWbUwyab0nPkn8{background-color:var(--gray-a-15);border-radius:4px;margin-bottom:20px;padding:3.5px 8px;display:inline-block}.YJVdCGvkWRsH8sYdT4cS{padding:30px 0}.LcFaF6rlGIwA837ansyM{width:100%;max-width:620px;padding-bottom:0;padding-left:80px;padding-right:75px;overflow-y:auto}.aort5C0rrMDZr6SaIRvo{border-left:1px solid var(--border-neutral-default);justify-content:center;padding-top:60px;padding-left:63px;padding-right:60px;display:flex}.XAtKKJqk32Tr9_a9MAdg{padding-top:30px}.pOyug9sI6Xs1j6piXzx2{margin-bottom:6px;margin-left:8px}.pOyug9sI6Xs1j6piXzx2:last-of-type{margin-bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `FPSviceBRNYINPm0E0lN`,
	"loading": `qUNKdg8HF0A__N47V84f`,
	"label": `mFYtB8TWbUwyab0nPkn8`,
	"box": `YJVdCGvkWRsH8sYdT4cS`,
	"box__main": `LcFaF6rlGIwA837ansyM`,
	"boxMain": `LcFaF6rlGIwA837ansyM`,
	"box__preview": `aort5C0rrMDZr6SaIRvo`,
	"boxPreview": `aort5C0rrMDZr6SaIRvo`,
	"section": `XAtKKJqk32Tr9_a9MAdg`,
	"section__box": `pOyug9sI6Xs1j6piXzx2`,
	"sectionBox": `pOyug9sI6Xs1j6piXzx2`
};
export default ___CSS_LOADER_EXPORT___;
